import * as React from "react";
import { observer } from "mobx-react";
import { withStores } from "stores";
import { BlossomComponents } from "components/flexFramework/BlossomComponents/BlossomComponents";
import {
  normalizeOptionsData,
  hasRenderableChilren,
  hasEmptyOptions,
} from "src/components/flexFramework/FlexTemplateNode";
import { UitkSpacing } from "uitk-react-spacing";

import { SpacingContainerProps, SpacingContainerFTNodeOptions } from "./typings";

const DEFAULT_SPACING = "six";
const DEFAULT_INLINE_SPACING = "three";

export const SpacingContainer = withStores(
  "flexModuleModelStore",
  "context"
)(
  observer((props: SpacingContainerProps) => {
    const { context, blossomComponent, flexModuleModelStore, flexTemplateNode } = props;

    /* istanbul ignore if */
    if (!blossomComponent || !flexTemplateNode || !flexModuleModelStore) {
      return null;
    }

    const options = normalizeOptionsData(
      flexTemplateNode,
      flexModuleModelStore.getModel(flexTemplateNode.id)
    ) as SpacingContainerFTNodeOptions;

    if (hasEmptyOptions(options) || !hasRenderableChilren(flexTemplateNode, flexModuleModelStore)) {
      return null;
    }

    const { a11yRegionLabel, a11yRegionAriaLabelTitle, spacingContainer, hasNoInlineSpacing } = options;

    const regionSpecificLabel = a11yRegionAriaLabelTitle || a11yRegionLabel || "";
    const spacingValue = spacingContainer || DEFAULT_SPACING;
    const inlineSpacingValue = hasNoInlineSpacing ? "unset" : DEFAULT_INLINE_SPACING;

    return (
      <UitkSpacing padding={{ block: spacingValue, inline: inlineSpacingValue }}>
        <div
          className={`SpacingContainer ${hasNoInlineSpacing ? " inlineSpacingContainerUnset" : ""}`}
          role="region"
          aria-label={regionSpecificLabel}
        >
          <BlossomComponents blossomComponent={blossomComponent} context={context} />
        </div>
      </UitkSpacing>
    );
  })
);

export default SpacingContainer;
